// extracted by mini-css-extract-plugin
module.exports = {"error_container":"SelectTranslationPopup_error_container__6JWW4","error_text":"SelectTranslationPopup_error_text__3LdpZ"};